(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5300);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(80419);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-wrap-balancer/dist/index.mjs
var dist = __webpack_require__(41782);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var wagmi_dist = __webpack_require__(38793);
// EXTERNAL MODULE: ./src/components/index.ts + 30 modules
var components = __webpack_require__(89408);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(97486);
// EXTERNAL MODULE: ./src/hooks/useFPTRegistry.ts + 1 modules
var useFPTRegistry = __webpack_require__(82194);
// EXTERNAL MODULE: ./src/hooks/useIsClient.ts
var useIsClient = __webpack_require__(17237);
// EXTERNAL MODULE: ./src/hooks/useNFTMetadata.ts
var useNFTMetadata = __webpack_require__(56647);
// EXTERNAL MODULE: ./src/hooks/useWalletNFTs.ts
var useWalletNFTs = __webpack_require__(28372);
;// CONCATENATED MODULE: ./src/hooks/index.ts






;// CONCATENATED MODULE: ./src/pages/index.tsx







const Home = ()=>{
    const isClient = (0,useIsClient/* useIsClient */.O)();
    const { isConnected  } = (0,wagmi_dist/* useAccount */.mA)();
    const toast = (0,index_esm/* useToast */.pm)({
        variant: "subtle",
        isClosable: true,
        position: "top-right"
    });
    const [selectedTokenSend, setselectedTokenSend] = (0,react.useState)(null);
    const [selectedTokenRetrieve, setselectedTokenRetrieve] = (0,react.useState)(null);
    const [selectedBulkTokens, setselectedBulkTokens] = (0,react.useState)(null);
    const { isOpen: isBulkRetrieveOpen , onOpen: openBulkRetrieve , onClose: closeBulkRetrieve  } = (0,dist_index_esm/* useDisclosure */.qY)();
    const { isOpen: isBulkSendToLoginOpen , onOpen: openBulkSendToLogin , onClose: closeBulkSendToLogin  } = (0,dist_index_esm/* useDisclosure */.qY)();
    const onClickRetrieve = (0,react.useCallback)((selectedToken)=>{
        setselectedTokenRetrieve(selectedToken);
    }, []);
    const onClickSend = (0,react.useCallback)((selectedToken)=>{
        setselectedTokenSend(selectedToken);
    }, []);
    const onClickBulkSend = (0,react.useCallback)(()=>{
        openBulkSendToLogin();
    }, [
        openBulkSendToLogin
    ]);
    const onClickBulkRetrieve = (0,react.useCallback)(()=>{
        openBulkRetrieve();
    }, [
        openBulkRetrieve
    ]);
    const onSelectBulkTokens = (0,react.useCallback)((selectedToken)=>{
        if (!selectedBulkTokens) {
            return setselectedBulkTokens({
                ...selectedToken,
                tokens: [
                    {
                        tokenId: selectedToken.tokenId,
                        parsedURI: selectedToken.parsedURI
                    }
                ]
            });
        }
        if ((selectedBulkTokens === null || selectedBulkTokens === void 0 ? void 0 : selectedBulkTokens.collection) !== selectedToken.collection) {
            return toast({
                title: "Error",
                description: "You can't select tokens from different collections",
                status: "error"
            });
        }
        if ((selectedBulkTokens === null || selectedBulkTokens === void 0 ? void 0 : selectedBulkTokens.status) !== selectedToken.status) {
            return toast({
                title: "Error",
                description: "You can't select tokens with different statuses",
                status: "error"
            });
        }
        if (selectedBulkTokens.tokens.find((param)=>{
            let { tokenId  } = param;
            return tokenId === selectedToken.tokenId;
        })) {
            return setselectedBulkTokens((prev)=>{
                if (!prev) return null;
                const tokens = prev.tokens.filter((param)=>{
                    let { tokenId  } = param;
                    return Number(tokenId) !== selectedToken.tokenId;
                });
                if (tokens.length === 0) return null;
                return {
                    ...selectedToken,
                    tokens
                };
            });
        }
        return setselectedBulkTokens((prev)=>{
            if (!prev) return null;
            return {
                ...prev,
                tokens: [
                    ...prev.tokens,
                    {
                        tokenId: selectedToken.tokenId,
                        parsedURI: selectedToken.parsedURI
                    }
                ]
            };
        });
    }, [
        selectedBulkTokens,
        toast
    ]);
    if (!isConnected && isClient) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ConnectWallet */.RZ, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SendToLoginDialogue */.zT, {
                selectedToken: selectedTokenSend,
                onClose: ()=>setselectedTokenSend(null)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RetrieveDialogue */.aK, {
                selectedToken: selectedTokenRetrieve,
                onClose: ()=>setselectedTokenRetrieve(null)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BulkSendToLoginDialogue */.l$, {
                selectedTokens: selectedBulkTokens,
                onSelectBulkTokens: onSelectBulkTokens,
                isOpen: isBulkSendToLoginOpen,
                onClose: ()=>closeBulkSendToLogin()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BulkRetrieveDialogue */.o1, {
                selectedTokens: selectedBulkTokens,
                onSelectBulkTokens: onSelectBulkTokens,
                isOpen: isBulkRetrieveOpen,
                onClose: ()=>closeBulkRetrieve()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                textAlign: "center",
                flexDir: "column",
                justifyContent: "center",
                alignItems: "center",
                my: "12",
                mx: "auto",
                maxW: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                        mt: "8",
                        zIndex: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            children: "FoolProof Token Dashboard"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                        mt: "3",
                        zIndex: "1",
                        color: "slate.600",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            children: "FoolProof Token (FPT) offers unparalleled security and control over digital assets by creating a 1:1 linked token to prove ownership without risking ownership."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Container */.W2, {
                my: {
                    base: 8,
                    md: 12
                },
                p: {
                    base: 4,
                    md: 12
                },
                maxW: "4xl",
                rounded: "md",
                w: "full",
                marginX: "auto",
                borderWidth: {
                    base: 0,
                    md: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ShadowCollections */.bz, {
                    onClickRetrieve: onClickRetrieve,
                    onClickSend: onClickSend,
                    onClickBulkRetrieve: onClickBulkRetrieve,
                    onSelectBulkTokens: onSelectBulkTokens,
                    onClickBulkSend: onClickBulkSend,
                    selectedBulkTokens: selectedBulkTokens
                })
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);